/*
 * fn: filterCombosByColorId
 *
 * Keeps the combos that can be played inside the given Color ID, or all of them when no Color ID is given
 *
 */
import { type ComboPreviewType } from '@/defs/combo'
import { type ColorIdType } from '@/defs/mtg'
import { isInColorId } from '@/utils/cardUtil'

type Props = {
  colorId?: ColorIdType
  combos: ComboPreviewType[]
}

export const filterCombosByColorId = ({ colorId, combos }: Props) =>
  colorId ? combos.filter((combo) => isInColorId(combo.colorId, colorId)) : combos
